import { useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractApiErrorMessage } from '../../shared/utils/extract-api-error-message.util';
import { Quote } from '../types/quote.type';
import { QUOTES_API_PATHS } from '../constants/quotes-paths.constants';

type UseCancelQuoteResult = {
  cancelQuote: (id: string) => Promise<Quote | null>;
  isSubmitting: boolean;
};

export function useCancelQuote(): UseCancelQuoteResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const cancelQuote = async (id: string): Promise<Quote | null> => {
    setIsSubmitting(true);

    try {
      const quote = await HttpClient.post<Quote>(QUOTES_API_PATHS.CANCEL(id), {});

      enqueueSnackbar('Devis annulé', { variant: 'success' });
      return quote;
    } catch (error) {
      enqueueSnackbar(
        extractApiErrorMessage(error, "Une erreur est survenue lors de l'annulation du devis"),
        { variant: 'error' }
      );
      return null;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { cancelQuote, isSubmitting };
}
